<template>
  <div class="releases-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">
          <i class="fas fa-history title-icon"></i>
          Últimos lançamentos
        </h3>
      </div>
    </div>

    <div class="card-content">
      <ErrorsMessages :errors="errors" />

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <div v-show="data.length == 0" class="no-results">
          <i class="fas fa-file-invoice no-results-icon"></i>
          <h4 class="no-results-title">Nenhum lançamento</h4>
          <p class="no-results-text">Não há transações recentes para exibir</p>
        </div>

        <div v-show="data.length > 0" class="releases-list">
          <div v-for="(item, key) in data" :key="key" class="release-item">
            <div class="release-info">
              <div class="release-icon">
                <i
                  :class="[
                    'fas',
                    item.type === 'TRANSFERENCIA'
                      ? 'fa-exchange-alt'
                      : item.type === 'CONTAS_A_PAGAR'
                      ? 'fa-file-invoice-dollar'
                      : 'fa-hand-holding-usd',
                  ]"
                ></i>
              </div>
              <div class="release-details">
                <div
                  v-if="item.type == 'TRANSFERENCIA'"
                  class="transfer-account"
                >
                  {{ item.account_nickname }}
                </div>
                <div class="release-description">
                  {{ item.description }}
                  <span
                    v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'"
                    class="repeat-indicator"
                  >
                    [{{ item.index_key }}/{{ item.how_many_times }}]
                  </span>
                </div>
                <div class="release-date">
                  <i class="fas fa-calendar mr-1"></i>
                  {{ item.date }}
                </div>
              </div>
            </div>

            <div class="release-actions">
              <div class="release-amount">
                <span
                  v-if="item.is_spent_or_gain == 'CREDITO'"
                  class="amount-positive"
                >
                  {{ formatMoney(String(item.value)) }}
                </span>
                <span
                  v-if="item.is_spent_or_gain == 'DEBITO'"
                  class="amount-negative"
                >
                  -{{ formatMoney(String(item.value)) }}
                </span>
              </div>
              <div class="release-status">
                <div
                  v-if="item.type == 'TRANSFERENCIA'"
                  class="status-badge transfer-status"
                >
                  <i class="fas fa-exchange-alt mr-1"></i>
                  Transferido
                </div>
                <div
                  v-if="
                    item.type == 'CONTAS_A_PAGAR' ||
                    item.type == 'CONTAS_A_RECEBER'
                  "
                  class="status-badge"
                  :class="[
                    item.type == 'CONTAS_A_PAGAR'
                      ? 'paid-status'
                      : 'received-status',
                  ]"
                >
                  <i class="fas fa-check mr-1"></i>
                  {{ item.type == "CONTAS_A_PAGAR" ? "Pago" : "Recebido" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import api from "../../../services/api";
import { formatMoney } from "../../../lib/format";
import moment from "moment";

export default {
  name: "LastReleases",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      data: [],
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatMoney,
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/overview/last-releases"
        );

        const { data } = response.data;

        this.data = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.releases-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
}

.card-header {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #818cf8;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #3730a3;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #4338ca;
  margin-right: 8px;
  font-size: 16px;
}

.card-content {
  padding: 24px;
  max-height: 400px;
  overflow-y: auto;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 200px;
}

.no-results {
  text-align: center;
  padding: 40px 24px;
}

.no-results-icon {
  font-size: 48px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.no-results-title {
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.releases-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.release-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  gap: 16px;
}

.release-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.release-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.release-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%);
}

.release-details {
  flex: 1;
  min-width: 0;
}

.transfer-account {
  font-size: 12px;
  color: #4338ca;
  font-weight: 600;
  margin-bottom: 2px;
  padding-bottom: 2px;
  border-bottom: 1px solid #e0e7ff;
}

.release-description {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
  margin-bottom: 4px;
  word-break: break-word;
}

.repeat-indicator {
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
}

.release-date {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
}

.release-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.release-amount {
  font-weight: 600;
  font-size: 14px;
}

.amount-positive {
  color: #10b981;
}

.amount-negative {
  color: #ef4444;
}

.release-status {
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.transfer-status {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  color: #4338ca;
  border: 1px solid #818cf8;
}

.paid-status {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.received-status {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

/* Scrollbar personalizada */
.card-content::-webkit-scrollbar {
  width: 6px;
}

.card-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.card-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.card-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .card-content {
    padding: 16px;
  }

  .release-item {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .release-actions {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .release-icon {
    width: 36px;
    height: 36px;
  }

  .transfer-account {
    font-size: 11px;
  }

  .release-description {
    font-size: 13px;
  }

  .status-badge {
    font-size: 10px;
    padding: 3px 6px;
  }
}
</style>